module.exports = __webpack_public_path__ + "static/media/audit.23f253b5.svg";